import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import SuccessSubmitImg from 'app/Components/Page/CellcomCareersPage/Shared/Utils/Img/successSubmit.svg';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import Config from 'app/Config';
import {buildUrlAndOpenSameWindow} from 'app/utilities/StringHelpers/StringHelpers';

const CareersSubmitSuccess = ({context, submitData, buttonData}) => {
  function backHomePage() {
    buildUrlAndOpenSameWindow(buttonData.buttonSuccesUrl);
  }
  return (
    <div className={'careers__success'}>
      <div className='careers__success__title'>
        <Image src={SuccessSubmitImg} alt='error' />

        <h1>תודה {submitData?.name}!</h1>
      </div>
      <div className='careers__success__message'>
        <p>
          קיבלנו את פרטיך עבור המשרה <span>{submitData?.title + ' '}</span>
          במידה ותימצא התאמה, ניצור עמך קשר באופן ישיר
        </p>
      </div>
      <div className='careers__success__button'>
        <BtnSubmit text={buttonData.buttonSuccesText} onclick={() => backHomePage()} />
      </div>
    </div>
  );
};
export default CareersSubmitSuccess;
